import type React from "react";

const TermsOfService: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <h1 className="text-3xl font-bold mb-6">Terms of Service</h1>

      <p className="mb-4">Last updated: {new Date().toLocaleDateString()}</p>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">Introduction</h2>
        <p className="mb-2">
          Welcome to the Washington ARML Team website. These Terms of Service
          govern your use of our website and the services we provide to
          Washington ARML team members.
        </p>
        <p>
          By using our website, you agree to these Terms of Service. If you do
          not agree, please do not use our website.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">Account Registration</h2>
        <p className="mb-2">
          To access certain features of our website, you may need to create an
          account. You are responsible for maintaining the confidentiality of
          your account information and for all activities that occur under your
          account.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">Acceptable Use</h2>
        <p className="mb-2">When using our website, you agree to:</p>
        <ul className="list-disc pl-6 mb-2">
          <li>
            Use the website for its intended purpose of participating in
            Washington ARML team activities
          </li>
          <li>Respect the privacy and rights of other users</li>
          <li>
            Not engage in any activity that could harm the website or interfere
            with other users' experience
          </li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">Intellectual Property</h2>
        <p>
          The content on this website, including text, graphics, logos, and
          software, is the property of the Washington ARML Team and is protected
          by copyright and other intellectual property laws.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">Limitation of Liability</h2>
        <p>
          The Washington ARML Team provides this website on an "as is" and "as
          available" basis. We make no warranties, expressed or implied,
          regarding the operation of the website or the information provided.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">Changes to Terms</h2>
        <p>
          We may update these Terms of Service from time to time. We will notify
          you of any changes by posting the new Terms on this page. You are
          advised to review these Terms periodically for any changes.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">Contact Us</h2>
        <p>
          If you have any questions about these Terms of Service, please contact
          us at:
        </p>
        <p className="mt-2">Email: armlwacoach@gmail.com</p>
      </section>
    </div>
  );
};

export default TermsOfService;
